interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  tone?: "light" | "dark";
  align?: "left" | "center";
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  tone = "light",
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "text-center max-w-3xl mx-auto" : "max-w-3xl"}>
      <span
        className={`inline-flex items-center gap-2 text-xs font-medium tracking-[0.18em] uppercase px-3 py-1.5 rounded-full ${
          tone === "dark"
            ? "bg-background-50/10 text-accent-300 ring-1 ring-background-50/20"
            : "bg-primary-50 text-primary-700 ring-1 ring-primary-200"
        }`}
      >
        <i className="ri-record-circle-line" aria-hidden="true"></i>
        {eyebrow}
      </span>
      <h2
        className={`mt-4 font-heading text-2xl md:text-4xl font-bold leading-tight tracking-tight ${
          tone === "dark" ? "text-background-50" : "text-foreground-950"
        }`}
      >
        {title}
      </h2>
      {description && (
        <p
          className={`mt-4 text-sm md:text-base leading-relaxed ${
            tone === "dark" ? "text-background-200/90" : "text-foreground-600"
          }`}
        >
          {description}
        </p>
      )}
    </div>
  );
}